/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FamiliesAndCategoriesRequest
 */
export interface FamiliesAndCategoriesRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof FamiliesAndCategoriesRequest
     */
    families: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FamiliesAndCategoriesRequest
     */
    categories: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof FamiliesAndCategoriesRequest
     */
    preferredFamilyId: string;
    /**
     * 
     * @type {string}
     * @memberof FamiliesAndCategoriesRequest
     */
    preferredCategoryId: string;
}

/**
 * Check if a given object implements the FamiliesAndCategoriesRequest interface.
 */
export function instanceOfFamiliesAndCategoriesRequest(value: object): value is FamiliesAndCategoriesRequest {
    if (!('families' in value) || value['families'] === undefined) return false;
    if (!('categories' in value) || value['categories'] === undefined) return false;
    if (!('preferredFamilyId' in value) || value['preferredFamilyId'] === undefined) return false;
    if (!('preferredCategoryId' in value) || value['preferredCategoryId'] === undefined) return false;
    return true;
}

export function FamiliesAndCategoriesRequestFromJSON(json: any): FamiliesAndCategoriesRequest {
    return FamiliesAndCategoriesRequestFromJSONTyped(json, false);
}

export function FamiliesAndCategoriesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FamiliesAndCategoriesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'families': json['families'],
        'categories': json['categories'],
        'preferredFamilyId': json['preferredFamilyId'],
        'preferredCategoryId': json['preferredCategoryId'],
    };
}

export function FamiliesAndCategoriesRequestToJSON(value?: FamiliesAndCategoriesRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'families': value['families'],
        'categories': value['categories'],
        'preferredFamilyId': value['preferredFamilyId'],
        'preferredCategoryId': value['preferredCategoryId'],
    };
}

